import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ComunaService {

    private readonly apiUrl = environment.apiEndpoint + 'comuna';

    constructor(private http: HttpClient) { }

    getComunas(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl, { withCredentials: true });
    }

    getComunaById(id: number | string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
    }

    getComunasByRegion(idRegion: number | string): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/region/${idRegion}`, { withCredentials: true });
    }
}
